import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    ksId = '',
    id,
    parentId,
    name,
    compareMode,
    value,
    nValue,
    unit,
    explain,
    summary,
    code,
    std,
    basis,
    scoreStd,
    order,
    classify = 0, // 1: 产出指标 2: 效益指标 3: 满意度指标
    scoreWeight = 1.0,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.kpiStorage.saveItem, {
        ksId,
        id,
        parentId,
        name,
        compareMode,
        value,
        nValue,
        unit,
        explain,
        summary,
        code,
        std,
        basis,
        scoreStd,
        order,
        classify,
        scoreWeight,
    }, options);
    if (error) return { error, status };
    return content || {};
};

